import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import DocumentCategory from "../../models/document-category";

const RECORS_PER_SEARCH = 20;

type DocumentCategorySelectProps = {
  value: DocumentCategory | null;
  disabled?: boolean;
  onChange: (_: DocumentCategory | null) => void;
};

const DocumentCategorySelect: React.FC<DocumentCategorySelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | DocumentCategory
      | { options: DocumentCategory[]; label?: string }
    )[]
  ): Promise<
    Response<
      DocumentCategory,
      { options: DocumentCategory[]; label?: string },
      any
    >
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<DocumentCategory>(
      "/document_categories/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: DocumentCategory[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Selecciona Categoría de Documento"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: DocumentCategory) => `${option.name}`}
      getOptionValue={(option: DocumentCategory) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default DocumentCategorySelect;
